import { TransactionCategory } from '../types/transaction';

export interface CategoryConfig {
  id: TransactionCategory;
  label: string;
  icon: string;
  color: string;
  keywords: string[];
}

export const CATEGORIES: CategoryConfig[] = [
  {
    id: 'accommodation',
    label: 'Accommodation',
    icon: 'bed',
    color: '#8b5cf6',
    keywords: ['hotel', 'airbnb', 'hostel', 'motel', 'resort', 'vrbo', 'booking.com', 'marriott', 'hilton', 'hyatt', 'inn', 'lodge'],
  },
  {
    id: 'flights',
    label: 'Flights',
    icon: 'plane',
    color: '#3b82f6',
    keywords: ['airline', 'airways', 'flight', 'united', 'delta', 'american airlines', 'southwest', 'jetblue', 'spirit', 'frontier', 'alaska air'],
  },
  {
    id: 'ground_transport',
    label: 'Ground Transport',
    icon: 'car',
    color: '#06b6d4',
    keywords: ['uber', 'lyft', 'taxi', 'cab', 'train', 'metro', 'subway', 'bus', 'amtrak', 'transit'],
  },
  {
    id: 'car_rental',
    label: 'Car Rental',
    icon: 'key',
    color: '#0891b2',
    keywords: ['hertz', 'avis', 'enterprise', 'budget', 'national', 'alamo', 'sixt', 'turo', 'zipcar'],
  },
  {
    id: 'food_dining',
    label: 'Food & Dining',
    icon: 'utensils',
    color: '#f59e0b',
    keywords: ['restaurant', 'cafe', 'diner', 'bistro', 'grubhub', 'doordash', 'uber eats', 'postmates', 'seamless'],
  },
  {
    id: 'groceries',
    label: 'Groceries',
    icon: 'shopping-cart',
    color: '#84cc16',
    keywords: ['grocery', 'supermarket', 'whole foods', 'trader joe', 'kroger', 'safeway', 'costco', 'walmart', 'target'],
  },
  {
    id: 'shopping',
    label: 'Shopping',
    icon: 'shopping-bag',
    color: '#ec4899',
    keywords: ['amazon', 'store', 'shop', 'mall', 'outlet', 'retail', 'market'],
  },
  {
    id: 'entertainment',
    label: 'Entertainment',
    icon: 'music',
    color: '#a855f7',
    keywords: ['cinema', 'theater', 'concert', 'museum', 'show', 'ticket', 'event', 'netflix', 'spotify'],
  },
  {
    id: 'activities',
    label: 'Activities & Tours',
    icon: 'compass',
    color: '#14b8a6',
    keywords: ['tour', 'excursion', 'viator', 'gettysburg', 'adventure', 'diving', 'snorkeling', 'hiking', 'ski'],
  },
  {
    id: 'health_medical',
    label: 'Health & Medical',
    icon: 'heart-pulse',
    color: '#ef4444',
    keywords: ['pharmacy', 'doctor', 'hospital', 'clinic', 'medical', 'health', 'cvs', 'walgreens'],
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: 'phone',
    color: '#64748b',
    keywords: ['phone', 'sim', 'data', 'wifi', 'internet', 'roaming'],
  },
  {
    id: 'insurance',
    label: 'Insurance',
    icon: 'shield',
    color: '#475569',
    keywords: ['insurance', 'coverage', 'policy', 'travel insurance', 'world nomads'],
  },
  {
    id: 'fees_charges',
    label: 'Fees & Charges',
    icon: 'receipt',
    color: '#78716c',
    keywords: ['fee', 'charge', 'atm', 'exchange', 'visa', 'customs', 'tax'],
  },
  {
    id: 'tips',
    label: 'Tips & Gratuity',
    icon: 'coins',
    color: '#d97706',
    keywords: ['tip', 'gratuity'],
  },
  {
    id: 'gifts_souvenirs',
    label: 'Gifts & Souvenirs',
    icon: 'gift',
    color: '#e11d48',
    keywords: ['gift', 'souvenir', 'present', 'memento'],
  },
  {
    id: 'laundry',
    label: 'Laundry',
    icon: 'shirt',
    color: '#0ea5e9',
    keywords: ['laundry', 'dry clean', 'wash', 'cleaners'],
  },
  {
    id: 'parking_tolls',
    label: 'Parking & Tolls',
    icon: 'square-parking',
    color: '#6366f1',
    keywords: ['parking', 'toll', 'garage', 'meter', 'ezpass'],
  },
  {
    id: 'fuel',
    label: 'Fuel',
    icon: 'fuel',
    color: '#854d0e',
    keywords: ['gas', 'fuel', 'petrol', 'shell', 'bp', 'exxon', 'chevron', 'station'],
  },
  {
    id: 'subscriptions',
    label: 'Subscriptions',
    icon: 'repeat',
    color: '#7c3aed',
    keywords: ['subscription', 'monthly', 'annual', 'membership', 'premium'],
  },
  {
    id: 'utilities',
    label: 'Utilities',
    icon: 'zap',
    color: '#ca8a04',
    keywords: ['electric', 'water', 'gas', 'utility', 'power', 'energy'],
  },
  {
    id: 'other',
    label: 'Other',
    icon: 'circle-dot',
    color: '#94a3b8',
    keywords: [],
  },
];

export const CATEGORY_MAP = new Map<string, CategoryConfig>(CATEGORIES.map((c) => [c.id, c]));
